import { IAbsenceWarning, TAbsenceWarningMoment } from 'shared/domain/entities';

export interface IVectisAbsenceWarning {
  exibirAviso: boolean;
  momento: TAbsenceWarningMoment | null;
  texto: string | null;
  quantidadeAtual: number;
  limite: number | null;
}

export class AbsenceWarning implements IAbsenceWarning {
  public shouldShow: IAbsenceWarning['shouldShow'];
  public moment: IAbsenceWarning['moment'];
  public message: IAbsenceWarning['message'];
  public currentCount: IAbsenceWarning['currentCount'];
  public limit: IAbsenceWarning['limit'];

  constructor({
    exibirAviso,
    momento,
    texto,
    quantidadeAtual,
    limite,
  }: IVectisAbsenceWarning) {
    this.shouldShow = exibirAviso;
    this.moment = momento;
    this.message = texto;
    this.currentCount = quantidadeAtual;
    this.limit = limite;
  }
}
